(() => {
  const emptyCartStateClass = 'is-empty-cart';
  const emptyCartDelayClass = 'is-delaying-empty-cart-upsell';
  const emptyCartTransitionMs = 1000;
  let isAwaitingEmptyCartRender = false;
  let emptyCartTransitionTimeout;
  let scanTimeout;

  const initSwiper = (slider, type) => {
    if (!window.Swiper || !slider || slider.swiper) return;

    const root = slider.closest('.cart-upsell') || slider;

    new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      direction: 'horizontal',
      mousewheel: {
        forceToAxis: true,
      },
      navigation:
        type === 'cart'
          ? {
              nextEl: root.querySelector('.cart-upsell_next'),
              prevEl: root.querySelector('.cart-upsell_previous'),
            }
          : false,
    });
  };

  const scan = () => {
    document
      .querySelectorAll('[js-empty-cart-upsell-slider]')
      .forEach((slider) => initSwiper(slider, 'empty'));

    document
      .querySelectorAll('[js-cart-upsell-slider]')
      .forEach((slider) => initSwiper(slider, 'cart'));

    syncEmptyCartState();
  };

  const syncEmptyCartState = () => {
    const hasEmptyCartUpsell = Boolean(document.querySelector('[data-empty-cart-upsell]'));

    if (isAwaitingEmptyCartRender || hasEmptyCartUpsell) {
      document.body.classList.add(emptyCartStateClass);
    } else {
      document.body.classList.remove(emptyCartStateClass);
    }

    if (isAwaitingEmptyCartRender) {
      document.body.classList.add(emptyCartDelayClass);
    } else {
      document.body.classList.remove(emptyCartDelayClass);
    }
  };

  const scheduleScan = () => {
    clearTimeout(scanTimeout);
    scanTimeout = setTimeout(scan, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  const observer = new MutationObserver(scheduleScan);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('cart:update', (event) => {
    setTimeout(scan, 100);

    const itemCount = event.detail?.data?.itemCount;
    const source = event.detail?.data?.source;

    clearTimeout(emptyCartTransitionTimeout);

    if (itemCount === 0 && source === 'cart-items-component') {
      isAwaitingEmptyCartRender = true;
      syncEmptyCartState();

      emptyCartTransitionTimeout = window.setTimeout(() => {
        isAwaitingEmptyCartRender = false;
        syncEmptyCartState();
      }, emptyCartTransitionMs);

      return;
    }

    isAwaitingEmptyCartRender = false;
    syncEmptyCartState();
  });
})();
